import { AsteriskNotification } from "Components/AsteriskNotification";
import { BulmaNavButtons } from "Components/BulmaNavButtons";
import { useDocumentTitle } from "Components/Hooks";
import { FormikValues } from "formik";
import { FitnessInstructorPurchasePolicyModel } from "SharedConstants/Schema";
import { formatDollarsAndCents } from "Tools";
import {
  isAgencyBillingSelected,
  isBankAccountSelected,
  PaymentInput,
} from "Views/Shared/PaymentInput";
import { SignatureInput } from "Views/Shared/SignatureInput";
import { Heading } from "../../Components/Heading";
import { MVCForm, MVCFormServerProps } from "../MVCForm";

export function PurchasePolicy(
  props: FitnessInstructorPurchasePolicyModel & {
    formProps: MVCFormServerProps;
  },
) {
  const shouldSubmit = (values: FormikValues) => {
    if (values.submit === "back") {
      return true;
    }
    if (isAgencyBillingSelected(props.PaymentInputProps, values)) {
      return window.confirm("Submit this policy?");
    } else {
      if (isBankAccountSelected(props.PaymentInputProps, values)) {
        return window.confirm(
          "Submit payment? Your bank account will be charged.",
        );
      } else {
        return window.confirm(
          "Submit payment? Your credit card will be charged.",
        );
      }
    }
  };
  useDocumentTitle(
    `Purchase ${props.PolicyNameInTitle} Policy - ${props.TitleProps.PageTitleSuffix}`,
  );
  return (
    <>
      <Heading
        {...props}
        title={`Purchase ${props.PolicyNameInHeading} Policy`}
      />
      <MVCForm {...props.formProps} shouldSubmit={shouldSubmit}>
        {({ isSubmitting }) => (
          <div className="narrowFieldBodies4">
            <AsteriskNotification />
            <PaymentInput
              {...props.PaymentInputProps}
              renderCCFeeNote={renderProps =>
                renderProps.CCFee > 0 && (
                  <>
                    (includes {formatDollarsAndCents(renderProps.CCFee)} Credit
                    Card Processing Fee)
                  </>
                )
              }
            />
            <SignatureInput {...props.SignatureInputProps} />
            <BulmaNavButtons
              backCaption="Back to Quote"
              continueCaption="Submit Payment"
              hideContinueIcon
              isDisabled={isSubmitting}
            />
          </div>
        )}
      </MVCForm>
    </>
  );
}
